import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_API_KEY,
  authDomain: import.meta.env.VITE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_APP_ID,
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

export default app;

export const getFirebaseFunctions = () => {
  const functions = getFunctions(app, "asia-northeast1");

  if (
    import.meta.env.DEV &&
    import.meta.env.VITE_FUNCTION_EMULATOR === "true"
  ) {
    connectFunctionsEmulator(functions, "localhost", 5001);
  }

  return functions;
};
